import { render, staticRenderFns } from "./DeviceSwitchView.vue?vue&type=template&id=27c71634&"
import script from "./DeviceSwitchView.vue?vue&type=script&lang=js&"
export * from "./DeviceSwitchView.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSwitchView.vue?vue&type=style&index=0&id=27c71634&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports